import { IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class MusicListItemDto {
    @IsNumber()
    projectId!: number;
    @IsString()
    assetCode!: string;
    @IsString()
    songArtist!: string;
    @IsString()
    songArtistImage!: string;
    @IsOptional()
    @IsString()
    songName!: string | null;
    @IsNumber()
    writingShare!: number;
    @IsString()
    @IsOptional()
    releaseDate!: string | null;
    gSongReleaseYear!: string | null;
    @IsString()
    label!: string;
    @IsNumber()
    totalRows!: number;
    @IsString()
    showSongStatus!: string;
    @IsString()
    showSongDealStatus!: string;
    @IsNumber()
    gSongEntryId!: number;
    // @IsString()
    // gSongFeatArtist1!: string;
    @IsOptional()
    @IsNumber()
    dealSongLinkFlag!: number;
    // @Type(() => SongProjectTrack)
    // @ValidateNested()
    songProjectTrack!: SongProjectTrack[];
    tags!: SongTags[];
}

export class MusicDetailDto {
    @Type(() => SongDetail)
    @ValidateNested()
    songDetail!: SongDetail;
    @Type(() => SongDeal)
    @ValidateNested()
    songDeals!: SongDeal[];
    @Type(() => SongKeyDates)
    @ValidateNested()
    gSongNotesEntry!: SongKeyDates[];
    @Type(() => SongProjectTrack)
    @ValidateNested()
    songProjectTrack!: SongProjectTrack[];
}

export class SongSummaryListDto {
    @IsOptional()
    @IsNumber()
    dealSongLinkFlag!: number;
    @IsNumber()
    projectId!: number;
    @IsString()
    assetCode!: string;
    @IsString()
    songArtist!: string;
    @IsOptional()
    @IsString()
    songName!: string | null;
    @IsNumber()
    writingShare!: number;
    @IsString()
    @IsOptional()
    releaseDate!: string | null;
    @IsString()
    label!: string;
    @IsNumber()
    totalRows!: number;
    @IsString()
    showSongStatus!: string;
    @IsString()
    showSongDealStatus!: string;
    @IsNumber()
    gSongEntryId!: number;
}

export class SongDetail {
    @IsNumber()
    projectId!: number;
    @IsString()
    assetCode!: string;
    @IsString()
    songArtist!: string;
    @IsOptional()
    @IsString()
    songName!: string | null;
    @IsNumber()
    writingShare!: number;
    gMyWriterName!: string | null;
    @IsNumber()
    publishingShare!: number;
    gPublisherName!: string | null;
    releaseDate!: string | null;
    @IsString()
    label!: string;
    @IsString()
    contractTitle!: string;
    @IsOptional()
    @IsString()
    dealSongLinkFlag!: string | null;
    @IsOptional()
    @IsString()
    trackArtist!: string | null;
    @IsString()
    isrc!: string;
    @IsString()
    upc!: string;
    @IsOptional()
    @IsString()
    featuredArtists!: any;
    @IsString()
    songArtistImage!: string;
    @IsNumber()
    gSongEntryId!: number;
    @IsString()
    gSongFeatArtist1!: string;
    @IsString()
    gSongFeatArtist2!: string;
    @IsString()
    gSongFeatArtist3!: string;
    @IsString()
    gSongFirstDeal!: string;
    @IsOptional()
    @IsNumber()
    isPubEligible!: number;
    @IsOptional()
    @IsNumber()
    isRecEligible!: number;
    @IsOptional()
    @IsNumber()
    isNBREligible!: number;
    @IsOptional()
    @IsNumber()
    isOtherEligible!: number;
    @IsOptional()
    @IsNumber()
    isWriterShareEligible!: number;
}

export class SongDeal {
    @IsString()
    songAssetCode!: string;
    @IsOptional()
    @IsString()
    songContract!: string | null;
    @IsOptional()
    @IsString()
    songContractTitle!: string | null;
    @IsOptional()
    @IsString()
    contractSongContact!: string | null;
    @IsString()
    contactImage!: string | null;
}

export class SongKeyDates {
    @IsOptional()
    gSongNotesEntryID!: any;
    @IsOptional()
    @IsString()
    gSongNotes!: string | null;
    @IsOptional()
    @IsString()
    gSongNoteEntryDate!: any | null;
    @IsOptional()
    @IsString()
    gSongNotesOther!: any | null;
    @IsOptional()
    @IsNumber()
    gSongNoteType!: number;
}

export class SongProjectTrack {
    @IsOptional()
    @IsString()
    isrc!: string;
    @IsOptional()
    @IsString()
    releaseDate!: string;
    @IsOptional()
    @IsString()
    trackArtist!: string;
    @IsOptional()
    @IsString()
    trackLabel!: string;
    @IsOptional()
    @IsString()
    trackTitle!: string;
    @IsOptional()
    upcList!: string[];
}

export class SongTags {
    type!: string;
    value!: string[];
}

export class SongDealsSummaryDto {
    @IsOptional()
    @IsNumber()
    dealSongLinkFlag!: number;
    @IsOptional()
    @IsNumber()
    projectId!: number;
    @IsOptional()
    @IsString()
    assetCode!: string;
    @IsOptional()
    @IsString()
    contractTitle!: string;
    @IsOptional()
    @IsString()
    contactDisplayContract!: string;
    @IsOptional()
    @IsString()
    contactNameContract!: string;
    @IsOptional()
    @IsString()
    contractType!: string;
    @IsOptional()
    @IsString()
    contractTerm!: string;
    @IsOptional()
    @IsString()
    contractDate!: string;
    @IsOptional()
    @IsString()
    contractStartDate!: string;
    @IsOptional()
    @IsString()
    contractEndDate!: string;
    @IsOptional()
    @IsString()
    accountingTerm!: string;
    @IsOptional()
    @IsNumber()
    accountingPeriod!: number;
    @IsOptional()
    @IsString()
    dealType!: string;
    @IsOptional()
    @IsString()
    incomeType!: string;
    @IsOptional()
    @IsNumber()
    statementDate!: number;
    @IsOptional()
    @IsNumber()
    contractBalance!: number;
    @IsOptional()
    @IsString()
    telephoneNumContract!: string;
    @IsOptional()
    @IsString()
    emailAddressContract!: string;
    @IsOptional()
    @IsString()
    addLine1Contract!: string;
    @IsOptional()
    @IsString()
    addLine2Contract!: string;
    @IsOptional()
    @IsString()
    addLine3Contract!: string;
    @IsOptional()
    @IsString()
    addLine4Contract!: string;
    @IsOptional()
    @IsString()
    websiteURLContract!: string;
    @IsOptional()
    @IsNumber()
    datesUnknown!: number;
    @IsOptional()
    @IsNumber()
    contractGayaaId!: number;
    @IsOptional()
    @IsString()
    addressPostCode!: string;
    @IsOptional()
    @IsString()
    firstName!: string;
    @IsOptional()
    @IsString()
    lastName!: string;
    @IsOptional()
    @IsNumber()
    step!: number;
    @IsOptional()
    @IsString()
    contactImage!: string;
    @IsOptional()
    @IsNumber()
    totalRows!: number;
    @IsOptional()
    @IsString()
    keyDates!: string;
    @IsOptional()
    @IsString()
    royaltyRates!: string | null;
    @IsOptional()
    @IsString()
    recoupables!: string;
}
